export default __webpack_public_path__ + "static/media/121.b04279db.jpg";